module.exports = __webpack_public_path__ + "img/hero_services.8452d329.jpg";